export enum Reporting {
    Access = "Reporting.Reporting.Access",
    Edit = "Reporting.Reporting.Edit",
}

export enum ExampleReport {
    View = "Reporting.Example Report.View",
    Download = "Reporting.Example Report.Download",
}

export enum RegulatoryReports {
    View = "Reporting.Regulatory Reports.View",
    Download = "Reporting.Regulatory Reports.Download",
}